import { useEffect, useState } from "react";
import { PageHero } from "../components/common/PageHero";
import { Reveal } from "../components/common/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { api } from "../lib/api";
import { usePageMeta } from "../lib/usePageMeta";

export const FaqPage = () => {
    usePageMeta("FAQ — Showtime Carnival Co. | NYC Cotton Candy & Popcorn",
        "Answers about Showtime event booking, flavors, service areas, wholesale and what's coming soon.");
    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        api.get("/faqs").then((res) => setFaqs(res.data || [])).catch(() => {});
    }, []);

    return (
        <>
            <PageHero
                kicker="FAQ"
                title="Good Questions."
                copy="Everything people ask before the show."
                dark={false}
                testid="faq-hero"
            />
            <section className="bg-white py-16 md:py-24">
                <div className="mx-auto max-w-3xl px-5 md:px-10">
                    <Reveal>
                        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                            {faqs.map((faq, i) => (
                                <AccordionItem key={faq.id} value={faq.id} className="border-b border-zinc-200">
                                    <AccordionTrigger
                                        data-testid={`faq-question-${i}`}
                                        className="font-oswald uppercase text-lg md:text-xl text-left py-6 hover:text-pink-dark transition-colors"
                                    >
                                        {faq.question}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-zinc-500 text-sm md:text-base leading-relaxed pb-6">
                                        {faq.answer}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                        {faqs.length === 0 && (
                            <p className="text-zinc-400 font-oswald uppercase tracking-widest py-10 text-center">FAQs are being written.</p>
                        )}
                    </Reveal>
                </div>
            </section>
        </>
    );
};
